import BaseRouter from './Base.js';
import Employees from 'newCollections/employees.js';
import Attachments from 'newCollections/attachments.js';
import Payrolls from 'newCollections/payrolls.js';
import EView from '../views/governmentForms/EForms.js';
import LHDNView from '../views/governmentForms/LHDNFiles.js';
import EaView from '../views/governmentForms/EaForms.js';
import EaViewMultiple from '../views/governmentForms/EaFormsMultiple.js';
import Pcb2View from '../views/governmentForms/Pcb2Forms.js';
import Pcb2ViewMultiple from '../views/governmentForms/Pcb2FormsMultiple.js';
import Log from 'lib/log';
import Loader from 'helpers/loader';
import moment from 'moment';
import queryString from 'query-string';

const log = Log('employer/govt-forms-router');

module.exports = BaseRouter.extend({
    routes: {
        'governmentForms': 'e',
        'governmentForms/e': 'e',
        'governmentForms/ea': 'ea',
        'governmentForms/ea/multiple/:actionMode': 'eaMultiple',
        'governmentForms/pcb2': 'pcb2',
        'governmentForms/pcb2/multiple': 'pcb2Multiple',
        'governmentForms/lhdn': 'lhdn'
    },

    titles: {
        'governmentForms': 'Government Forms',
        'governmentForms/e': 'Government Form E',
        'governmentForms/ea': 'Government Form EA',
        'governmentForms/ea/multiple': 'Multiple Government Form EA',
        'governmentForms/pcb2': 'Government Form PCB II',
        'governmentForms/pcb2/multiple': 'Multiple Government Form PCB II',
        'governmentForms/lhdn': 'LHDN Audit Files'
    },

    initialize: function(options) {
        this.options = _.defaults(options || {}, {log: log});
        BaseRouter.prototype.initialize.apply(this, [this.options]);
    },

    e: function() {
        const params = queryString.parse(window.location.search);

        var stopLoader = Loader.startFullPage(this.el);

        const year = params.year || 2025;

        const payrolls = new Payrolls(null, {
            company: app.company
        });

        const attachments = new Attachments(null, {
            attachable: app.company,
            pagination: false
        });

        const startOfYear = moment().year(year).startOf('year').toDate();
        const endOfYear = moment().year(year).endOf('year').toDate();

        return Promise.all([
            payrolls.fetch({filter: {
                where: {
                    status: {eq: 9},
                    and: [
                        {periodDate: {gte: startOfYear}},
                        {periodDate: {lte: endOfYear}}
                    ]
                }
            }}),
            attachments.fetch({filter: {
                where: {tags: 'E'},
                limit: 30
            }})
        ]).then(() => {
            this.view = new EView({
                el:          this.el,
                model:       app.company,
                attachments: attachments,
                hideFormEButton: false,
                year: year
            });
        })
            .finally(stopLoader);
    },

    fetchEaFormEmployees: function(year) {
        return app.company.fetchFormEAEmployees(year || moment().year() - 1);
    },

    fetchEmployeesAttachments: function(tag, employees = []) {
        return Promise.all(
            employees.map(emp => emp.fetchAttachments([tag]))
        ).then(attachmentList => {
            return _.indexBy(attachmentList, (att, i) => employees[i].id);
        });
    },

    ea: function() {
        const params = queryString.parse(window.location.search);
        var stopLoader = Loader.startFullPage(this.el);

        return this.fetchEaFormEmployees(params.year || 2025)
            .then((employees) => Promise.all([
                employees,
                this.fetchEmployeesAttachments(
                    'EA', employees.models
                )
            ])
            ).then(([employees, employeeAttachments]) => {
                const view = new EaView({
                    el:          this.el,
                    model:       app.company,
                    collection:  employees,
                    attachments: employeeAttachments
                }).render();
                this.view = view;
            }).finally(stopLoader);
    },

    eaMultiple: function(actionMode) {
        const params = queryString.parse(window.location.search);
        var stopLoader = Loader.startFullPage(this.el);
        return this.fetchEaFormEmployees(params.year || undefined)
            .then((employees) => {
                const view = new EaViewMultiple({
                    el:          this.el,
                    model:       app.company,
                    collection:  employees,
                    actionMode
                }).render();
                this.view = view;
            }).finally(stopLoader);
    },

    pcb2: function() {
        var stopLoader = Loader.startFullPage(this.el);

        if (
            ![`admin_manager`, `super_admin`, `employer`, `mpp_admin`]
                .includes(app.user.get(`role`))
        ) {
            app.mainRouter.navigate('dashboard', {trigger: true});
            return;
        }

        const employees = new Employees(null, {
            company: app.company,
            pagination: false
        });
        return employees.fetch({
            filter: {
                where: {
                    // exclude Freelancers
                    residentSubType: {
                        nin: [3]
                    }
                },
                limit: 9999
            },
            validate: false
        }).then(() => this.fetchEmployeesAttachments(
            'PCB2', employees.models
        ))
            .then(employeeAttachments => {
                const view = new Pcb2View({
                    el: this.el,
                    model: app.company,
                    collection: employees,
                    attachments: employeeAttachments
                }).render();
                this.view = view;
            }).finally(stopLoader);
    },

    pcb2Multiple: function() {
        var stopLoader = Loader.startFullPage(this.el);
        return this.fetchEaFormEmployees(2025).then((employees) =>
            Promise.all([
                employees,
                this.fetchEmployeesAttachments(
                    'PCB2', employees.models
                )
            ])
        ).then(([employees, employeeAttachments]) => {
            const view = new Pcb2ViewMultiple({
                el:          this.el,
                model:       app.company,
                collection:  employees,
                attachments: employeeAttachments
            }).render();
            this.view = view;
        }).finally(stopLoader);
    },

    lhdn: function() {
        var stopLoader = Loader.startFullPage(this.el);

        const attachments = new Attachments(null, {
            attachable: app.company,
            pagination: false
        });

        return attachments.fetch({filter: {limit: 9999}})
            .then(() => {
                this.view = new LHDNView({
                    el:          this.el,
                    model:       app.company,
                    attachments: attachments.findByTags(['lhdn-audit'])
                });
            })
            .finally(stopLoader);
    },
});



// WEBPACK FOOTER //
// ./app/employer/routers/GovernmentForms.js